// import '../audio/recorder.js';
import UIComponent from "../ui/component.js";
import api from "../api/index.js";
import goals from "../utils/goals.js";

export class UploadLinkForm extends UIComponent {
    init() {
        // this.requireComponents({ upload: "document@#upload-form" });
        // this.reset();

        this.submitBtn.on("click", (e) => {
            e.preventDefault();
            this.startUploadByLink();
        });

        this.link.on("keypress", (keyPressEvent) => {
            if (keyPressEvent.key !== "Enter") {
                return;
            }
            this.startUploadByLink();
        });
    }

    // Возвращает форму в исходное состояние
    // reset() {
    //     this.submitBtn.enable();
    //     this.notification.element.classList.add('d-none');
    // }

    onSuccess(file) {}

    onError(error) {}

    startUploadByLink() {
        goals.reach("startFileUploadLink");
        let url = this.attr("data-url");
        if (!url) {
            return;
        }

        if(!this.link.element.value){
            return
        }

        // this.submitBtn.disable();
        // this.notification.element.classList.remove('d-none');

        this.notification.show();

        api.post(url, {
            link: this.link.element.value,
        })
            .then((data) => {
                // console.log(data);
                if (data.throwable_error) {
                    this.onError(data.throwable_error);
                } else {
                    this.onSuccess({ ...data[0] });
                }
                this.link.element.value = "";
            })
            .catch((error) => this.onError(error));
    }
}
